import React from 'react';
import { isEmpty } from 'lodash';
import { Button, Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const Options = ({ groupProps, loading, refreshProps, toggleProps }) => {
  const { toggled, onToggle, ...rest } = toggleProps;
  const { refresh, ...restRefresh } = refreshProps;
  return (
    <Button.Group {...groupProps}>
      {!isEmpty(toggleProps) ? (
        <Button
          icon
          id="toggle"
          labelPosition="left"
          onClick={() => toggleProps.onToggle()}
          {...rest}
        >
          <Icon
            name={
              toggleProps.toggled ? 'check square outline' : 'square outline'
            }
          />
          {toggleProps.text || 'Toggle'}
        </Button>
      ) : null}
      {!isEmpty(refreshProps) ? (
        <Button
          icon
          id="refresh"
          labelPosition={refreshProps.text ? 'left' : null}
          disabled={loading}
          onClick={() => refreshProps.refresh()}
          {...restRefresh}
        >
          <Icon name="refresh" loading={loading} {...refreshProps.icon} />
          {refreshProps.text}
        </Button>
      ) : null}
    </Button.Group>
  );
};

Options.propTypes = {
  groupProps: PropTypes.objectOf(PropTypes.any),
  loading: PropTypes.bool,
  refreshProps: PropTypes.objectOf(PropTypes.any),
  toggleProps: PropTypes.objectOf(PropTypes.any),
};

Options.defaultProps = {
  groupProps: {},
  loading: false,
  refreshProps: {},
  toggleProps: {},
};

export default Options;
